import React, { useState } from "react";

export default function ButtonPrimary({
  className,
  onClick,
  text,
  style,
  onFocus,
  onMouseOver,
  onMouseOut,
}) {
  const [mouse, setMouse] = useState("unclick");
  return (
    <button
      id={mouse}
      onFocus={onFocus}
      onMouseOut={onMouseOut}
      className={className}
      onMouseOver={onMouseOver}
      style={style}
      onMouseDown={() => {
        setMouse("unclick");
        // console.log("onMouseDown");
      }}
      onMouseUp={() => {
        setMouse("click");
        // console.log("onMouseUp");
      }}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
